import { SvgIcon, SvgIconProps } from '@mui/material';

const AddOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="AddOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M20 13H13V20H11V13H4V11H11V4H13V11H20V13Z" />
    </SvgIcon>
  );
};

export default AddOutlined;
